class AnalyticsServiceGlobalHelper extends AnalyticsService {
  constructor() {
    super();
    this.init();
  }

  // HELPERS

  // CORE FUNCTIONS
  initTopBannerClick() {
    const topBannerLinks = document.querySelectorAll(
      '[data-a-target-id="banner-top"]'
    );

    if (!topBannerLinks) return;

    topBannerLinks.forEach((link) => {
      link.addEventListener("click", () => {
        const event = this.buildAnalyticsEvent("analytics:topBannerClick", {
          banner_name: link.querySelector("p").textContent.trim(),
          banner_url: link.querySelector("[data-url]").dataset.url,
          page_location: window.location.pathname,
        });
        document.dispatchEvent(event);
      });
    });
  }

  initDesktopNavTier1Hover() {
    const desktopNavLinks = document.querySelectorAll(
      '[data-a-target-id="header"] [data-a-target-id="header-toggle"] [data-a-target-id="top-nav-link"]'
    );
    if (!desktopNavLinks) return;

    desktopNavLinks.forEach((link) => {
      link.addEventListener("mouseenter", () => {
        const event = this.buildAnalyticsEvent("analytics:navHover", {
          navigation_hover_element: link.textContent.trim(),
          page_location: window.location.pathname,
        });
        document.dispatchEvent(event);
      });
    });
  }
  initMobileNavOpen() {
    const mobileNavButton = document.querySelector(
      "[data-a-target-id='mobile-nav-hamburger']"
    );
    if (!mobileNavButton) return;

    mobileNavButton.addEventListener("click", () => {
      if (document.querySelector(".header__menu:not(.hidden)")) return; // only track when opening, not closing
      const event = this.buildAnalyticsEvent("analytics:mobileNavOpen", {
        page_location: window.location.pathname,
      });
      document.dispatchEvent(event);
    });
  }
  initTopNavClick() {
    const topNavLinks = document.querySelectorAll(
      "[data-a-target-id='top-nav-link']"
    );
    if (!topNavLinks) return;
    topNavLinks.forEach((link) => {
      link.addEventListener("click", () => {
        const event = this.buildAnalyticsEvent("analytics:topNavClick", {
          top_nav_click_element: this.determineTopNavClickElement(link),
          page_location: window.location.pathname,
        });
        document.dispatchEvent(event);
      });
    });
  }
  determineTopNavClickElement(link) {
    if (link.href?.includes("/cart")) return "Cart";
    if (link.dataset?.action === "Login Modal Click") return "Account";
    const text = link.textContent?.trim();
    if (!text) return "Logo";
    return text;
  }
  initSecondTierNavClick() {
    const secondTierLinks = document.querySelectorAll(
      "[data-a-target-id='header'] [data-a-target-id='tier-2-nav-link']"
    );
    if (!secondTierLinks) return;
    secondTierLinks.forEach((link) => {
      link.addEventListener("click", () => {
        const event = this.buildAnalyticsEvent("analytics:secondTierNavClick", {
          second_tier_nav_click_element:
            link.querySelector(".resizing-text")?.textContent.trim() ||
            link.dataset.aTitle ||
            link.textContent.trim(),
          page_location: window.location.pathname,
        });
        document.dispatchEvent(event);
      });
    });
  }
  initThirdTierNavClick() {
    const thirdTierLinks = document.querySelectorAll(
      "[data-a-target-id='header'] [data-a-target-id='tier-3-nav-link']"
    );
    if (!thirdTierLinks) return;
    thirdTierLinks.forEach((link) => {
      link.addEventListener("click", () => {
        const event = this.buildAnalyticsEvent("analytics:thirdTierNavClick", {
          third_tier_nav_click_element: link.textContent.trim(),
          page_location: window.location.pathname,
        });
        document.dispatchEvent(event);
      });
    });
  }
  initSearchIconClick() {
    const searchIcons = document.querySelectorAll(
      "[data-a-target-id='search-icon']"
    );

    if (!searchIcons) return;

    searchIcons.forEach((icon) => {
      icon.addEventListener("click", () => {
        const searchShown = document.querySelector(
          this.device == "desktop"
            ? "#search_nav.active"
            : ".header__search.header__nav:not(.hide_mobile)"
        );
        const event = this.buildAnalyticsEvent(
          `analytics:search${searchShown ? "CloseResults" : "IconClick"}`,
          {
            page_location: window.location.pathname,
          }
        );
        document.dispatchEvent(event);
      });
    });
  }
  initSearchSuggestedClick() {
    const searchSuggestions = document.querySelectorAll(
      this.device == "desktop"
        ? "[data-a-target-id='search-suggestion'] [data-a-target-id='link-card']"
        : "[data-a-target-id='search-suggestion'] [data-a-target-id='search-suggestion-mobile-link']"
    );

    if (!searchSuggestions) return;
    searchSuggestions.forEach((suggestion) => {
      suggestion.addEventListener("click", (e) => {
        let dataset = suggestion.dataset;

        const event = this.buildAnalyticsEvent(
          "analytics:searchSuggestedClick",
          {
            page_location: window.location.pathname,
            handle: dataset.aUrl.split("/").pop(),
            image_card_name: dataset.aCardTitle,
          }
        );
        document.dispatchEvent(event);
      });
    });
  }
  initSearchResultsView() {
    document.addEventListener(
      "analytics:GlobalHelper:searchResultsView",
      (e) => {
        const searchTerm = e.detail?.searchTerm?.trim();
        if (!searchTerm || searchTerm === "(not set)") return;
        const event = this.buildAnalyticsEvent("analytics:searchResultsView", {
          page_location: window.location.pathname,
          search_term: searchTerm,
        });
        document.dispatchEvent(event);
      }
    );
  }
  initSearchResultClick() {
    document.addEventListener(
      "analytics:GlobalHelper:searchResultClick",
      (e) => {
        const searchTerm = new URLSearchParams(window.location.search).get("q")?.trim();
        if (!searchTerm || searchTerm === "(not set)") return;
        const event = this.buildAnalyticsEvent("analytics:searchResultClick", {
          page_location: window.location.pathname,
          search_term: searchTerm,
          handle: e.detail.handle,
        });
        document.dispatchEvent(event);
      }
    );
  }
  initFooterScrolledIntoView() {
    const footer = document.querySelector("[data-a-target-id='footer']");
    if (!footer) return;

    let footerViewed = false; // Guard flag

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !footerViewed) {
            footerViewed = true; // Set the guard
            const event = this.buildAnalyticsEvent("analytics:footerView", {
              page_location: window.location.pathname,
            });
            const impressionEvent = this.buildAnalyticsEvent(
              "analytics:newsletterImpression",
              {
                page_location: window.location.pathname,
                internal_source: "Newsletter Footer",
              }
            );
            document.dispatchEvent(impressionEvent);
            document.dispatchEvent(event);
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(footer);
  }
  initFooterClick() {
    const footerLinks = document.querySelectorAll(
      "[data-a-target-id='footer-link']"
    );
    if (!footerLinks) return;

    footerLinks.forEach((link) => {
      link.addEventListener("click", () => {
        const event = this.buildAnalyticsEvent("analytics:footerClick", {
          footer_click_element: link.textContent.trim(),
          page_location: window.location.pathname,
        });
        document.dispatchEvent(event);
      });
    });
  }
  initGenericPageScrollDepth() {
    // Skip on PLP pages — they use the custom plp_scroll event instead
    if (this.pageType === "collections") return;

    const thresholds = [25, 50, 75, 100];
    const trackedThresholds = new Set();
    let isMagazinPage =
      document.querySelector(".lookbook-page-wrapper") !== null;

    const handleScroll = this.throttle(() => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const scrollHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      if (scrollHeight <= 0) return;
      const percentScrolled = Math.round((scrollTop / scrollHeight) * 100);

      for (const threshold of thresholds) {
        if (percentScrolled >= threshold && !trackedThresholds.has(threshold)) {
          trackedThresholds.add(threshold);
          const event = this.buildAnalyticsEvent("analytics:pageScrollDepth", {
            page_location: window.location.pathname,
            pageType: isMagazinPage ? "magazin" : this.pageType,
            percent_scrolled: threshold,
          });
          document.dispatchEvent(event);
        }
      }
    }, 500); // Throttle every 500ms

    window.addEventListener("scroll", handleScroll);
  }
  // newsletter
  initNewsletterImpression() {
    document.addEventListener(
      "analytics:GlobalHelper:newsletterImpression",
      (e) => {
        const event = this.buildAnalyticsEvent(
          "analytics:newsletterImpression",
          e.detail
        );
        document.dispatchEvent(event);
      }
    );
  }
  initNewsletterSignup() {
    document.addEventListener(
      "analytics:GlobalHelper:newsletterSignup",
      (e) => {
        const event = this.buildAnalyticsEvent(
          "analytics:newsletterSignup",
          e.detail
        );
        document.dispatchEvent(event);
      }
    );
  }

  initCartView() {
    const cartButtons = document.querySelectorAll(
      "header [data-a-target-id='view-cart']"
    );
    if (!cartButtons) return;
    cartButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const event = this.buildAnalyticsEvent("analytics:headerViewCart", {
          page_location: window.location.pathname,
        });
        document.dispatchEvent(event);
      });
    });
  }

  // INITIALIZATION
  init() {
    this.initTopBannerClick();
    this.initDesktopNavTier1Hover();
    this.initMobileNavOpen();
    this.initTopNavClick();
    this.initSecondTierNavClick();
    this.initThirdTierNavClick();
    // Search related events
    this.initSearchIconClick();
    this.initSearchSuggestedClick();
    this.initSearchResultsView();
    this.initSearchResultClick();
    // footer related events
    this.initFooterScrolledIntoView();
    this.initFooterClick();
    // Generic page scroll depth tracking
    this.initGenericPageScrollDepth();
    // Newsletter
    this.initNewsletterImpression();
    this.initNewsletterSignup();
    // Cart
    this.initCartView();
  }
}

window.AnalyticsServiceGlobalHelper = new AnalyticsServiceGlobalHelper();
